import Form, { FormProps } from "@/shared/form/form";
import Input from "@/shared/form/input";
import { SubmitButton } from "@/shared/form/button";
import { SendOutlined } from "@ant-design/icons";
import { AiAssistantSubscriptionVariables } from "gql/graphql";
import { useTranslations } from "use-intl";

/** В форме только вопрос — id разговора клиент подставляет сам. */
export type QuestionFormValues = Pick<
  AiAssistantSubscriptionVariables,
  "question"
>;

export function SendQuestionForm({
  loading,
  ...props
}: FormProps<QuestionFormValues> & {
  loading?: boolean;
}) {
  const t = useTranslations("AI");

  return (
    <Form className={"flex gap-2"} {...props}>
      <Form.Item name={"question"} className={"grow !mb-0"}>
        <Input placeholder={t("Ask your question")} disabled={loading} />
      </Form.Item>

      <Form.Item className={"!mb-0"}>
        <SubmitButton icon={<SendOutlined />} loading={loading}>
          {null}
        </SubmitButton>
      </Form.Item>
    </Form>
  );
}
